export default __webpack_public_path__ + "static/media/cancel-copy.380bb51b.svg";